import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetTruckComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <g clipPath="url(#a)">
        <path
          d="M36.477 66.345c0 1.772-1.257 3.94-2.808 4.826-.698.4-1.339.477-1.825.27a.2.2 0 0 1-.063-.02c-.569-.27-.92-.915-.92-1.859 0-1.772 1.257-3.95 2.808-4.836.665-.38 1.277-.467 1.758-.289h.01c.26.154.482.323.64.477.097.11.164.25.217.4v.01q.181.432.183 1.016z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M32.412 72.033a2 2 0 0 1-.703-.125c-.053-.014-.101-.034-.14-.048-.756-.357-1.19-1.195-1.19-2.293 0-1.932 1.368-4.292 3.05-5.255.765-.444 1.502-.554 2.133-.333.044.01.082.03.12.048.29.174.545.362.733.55.154.178.255.36.332.578q.001.014.01.033.202.506.202 1.156c0 1.96-1.339 4.263-3.049 5.246-.515.294-1.026.443-1.493.443zm-.457-1.06a.4.4 0 0 1 .072.025c.361.154.857.067 1.401-.246 1.393-.795 2.563-2.813 2.563-4.408 0-.322-.048-.602-.144-.828a.4.4 0 0 1-.024-.072.6.6 0 0 0-.12-.212 3 3 0 0 0-.468-.347c-.352-.126-.819-.034-1.33.26-1.392.8-2.567 2.818-2.567 4.417 0 .703.217 1.204.612 1.411z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M35.427 64.442c-.481-.183-1.093-.096-1.758.29-1.546.886-2.808 3.058-2.808 4.836 0 .948.351 1.59.92 1.859-1.084-.29-2.712-1.363-3.107-1.59-.506-.289-.824-.915-.824-1.801 0-1.782 1.257-3.95 2.808-4.837.848-.486 1.61-.496 2.125-.096.27.207 1.686.756 2.64 1.34z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.782 71.903a.6.6 0 0 1-.125-.014c-.968-.255-2.245-1.04-2.934-1.465-.125-.077-.226-.14-.289-.173-.674-.38-1.064-1.19-1.064-2.216 0-1.965 1.339-4.272 3.049-5.25.997-.573 1.97-.597 2.659-.058.082.058.467.24.775.38.559.26 1.258.583 1.821.925a.478.478 0 0 1-.42.857c-.35-.134-.828-.042-1.348.256-1.392.8-2.567 2.818-2.567 4.417 0 .723.226 1.229.64 1.426a.48.48 0 0 1 .246.602.49.49 0 0 1-.453.318zm.13-8.603c-.299 0-.64.106-1.007.318-1.392.8-2.567 2.818-2.567 4.417 0 .67.212 1.176.578 1.383q.108.064.318.192c.294.183.746.458 1.228.723a3.5 3.5 0 0 1-.077-.761c0-1.932 1.368-4.292 3.05-5.255.115-.068.235-.126.35-.179q-.166-.08-.327-.154c-.525-.24-.804-.376-.958-.491a.9.9 0 0 0-.583-.183z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M70.288 46.923c0 1.772-1.257 3.94-2.808 4.826-.699.4-1.34.477-1.826.27a.2.2 0 0 1-.063-.02c-.568-.269-.92-.914-.92-1.859 0-1.772 1.258-3.95 2.809-4.836.664-.38 1.276-.467 1.758-.289h.01c.26.16.481.323.64.477.096.11.164.25.217.4v.01q.182.431.183 1.016z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M66.227 52.611q-.376-.001-.708-.125c-.063-.014-.116-.038-.15-.053-.746-.352-1.18-1.19-1.18-2.288 0-1.965 1.34-4.273 3.05-5.255.765-.444 1.502-.56 2.129-.333.043.01.086.03.12.048.29.174.544.362.732.55.154.178.256.356.333.578 0 .01.01.024.01.033.134.333.202.723.202 1.157 0 1.96-1.34 4.262-3.05 5.245-.515.294-1.026.443-1.493.443zm-.458-1.06a.4.4 0 0 1 .073.025c.361.154.857.067 1.401-.246 1.392-.795 2.563-2.813 2.563-4.407 0-.323-.048-.603-.144-.83a.4.4 0 0 1-.025-.071.7.7 0 0 0-.12-.212 2.8 2.8 0 0 0-.467-.347c-.352-.125-.82-.034-1.33.26-1.392.795-2.567 2.818-2.567 4.417 0 .703.217 1.204.612 1.412zm.02.01h.01z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M69.237 45.02c-.481-.183-1.093-.096-1.758.29-1.546.885-2.808 3.058-2.808 4.835 0 .95.351 1.59.92 1.86-1.084-.29-2.712-1.364-3.107-1.59-.506-.289-.824-.915-.824-1.801 0-1.783 1.257-3.95 2.809-4.837.847-.486 1.608-.496 2.124-.096.27.207 1.686.756 2.64 1.34z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M65.59 52.486a.6.6 0 0 1-.125-.015c-.968-.255-2.244-1.04-2.933-1.464-.125-.077-.227-.14-.29-.174-.674-.38-1.064-1.19-1.064-2.215 0-1.966 1.34-4.273 3.05-5.256.997-.573 1.97-.597 2.658-.058.082.063.468.241.78.386.56.26 1.258.583 1.822.925a.478.478 0 0 1-.42.857c-.351-.13-.828-.043-1.348.255-1.392.795-2.568 2.818-2.568 4.418 0 .722.227 1.228.64 1.425a.48.48 0 0 1 .246.602.49.49 0 0 1-.452.318zm.13-8.608c-.298 0-.64.106-1.006.318-1.392.794-2.568 2.818-2.568 4.417 0 .67.212 1.175.578 1.382q.11.064.318.193c.294.183.747.457 1.229.722a3.5 3.5 0 0 1-.077-.76c0-1.966 1.339-4.273 3.049-5.256a3 3 0 0 1 .351-.178q-.167-.078-.327-.15c-.525-.245-.81-.375-.963-.496a.9.9 0 0 0-.583-.183z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M74.71 37.332V18.387c0-.882-.626-1.243-1.397-.805L37.86 37.934c-.77.448-1.397 1.518-1.397 2.399v18.955l-18.357-8.632V29.909c0-.881.626-1.95 1.396-2.399L54.955 7.163c.771-.438 19.943 9.947 19.943 10.839l-.183 19.335z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.463 59.774a.5.5 0 0 1-.207-.044L17.898 51.1a.49.49 0 0 1-.274-.439V29.914c0-1.046.717-2.284 1.637-2.818L54.714 6.744c.284-.16.602-.342 6.205 2.524a230 230 0 0 1 9.662 5.265c4.798 2.789 4.798 3.117 4.798 3.463l-.183 19.34a.48.48 0 0 1-.482.477.483.483 0 0 1-.481-.481V18.387c0-.241-.063-.42-.169-.477-.106-.058-.299-.024-.51.096L38.1 38.358c-.626.36-1.156 1.271-1.156 1.984v18.955a.486.486 0 0 1-.481.482zm-17.88-9.417 17.393 8.179V40.342c0-1.045.718-2.283 1.638-2.818l35.458-20.356c-4.2-2.698-16.388-9.234-17.987-9.523L19.738 27.934c-.626.361-1.156 1.271-1.156 1.98v20.443"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M74.708 18.386v18.945l-38.251 21.96V40.338c0-.881.626-1.95 1.396-2.399l35.453-20.351c.771-.439 1.397-.078 1.397.804z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.463 59.774a.5.5 0 0 1-.24-.062.48.48 0 0 1-.242-.42V40.338c0-1.046.718-2.284 1.638-2.818l35.458-20.357c.525-.298 1.06-.332 1.474-.091.41.24.645.717.645 1.31v18.945a.48.48 0 0 1-.24.42l-38.252 21.96a.5.5 0 0 1-.24.062zm37.471-41.898a.8.8 0 0 0-.38.125L38.1 38.353c-.626.361-1.156 1.272-1.156 1.985v18.121l37.288-21.406V18.387c0-.241-.063-.42-.169-.477a.26.26 0 0 0-.13-.03z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M43.384 48.33a.49.49 0 0 1-.42-.24.487.487 0 0 1 .18-.66l24.402-14.008a.487.487 0 0 1 .66.178.487.487 0 0 1-.178.66L43.625 48.268a.5.5 0 0 1-.241.062M43.384 41.832a.49.49 0 0 1-.42-.241.487.487 0 0 1 .18-.66l24.402-14.008a.487.487 0 0 1 .66.178.487.487 0 0 1-.178.66L43.625 41.77a.5.5 0 0 1-.241.063"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M7.71 49.37a2.6 2.6 0 0 1-1.435.212 2.63 2.63 0 0 1-1.464-.713v-3.242c.255-.091.79-.245 1.464-.144a3 3 0 0 1 1.436.646z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M6.625 50.088q-.202 0-.419-.03a3.16 3.16 0 0 1-1.734-.842.48.48 0 0 1-.15-.347v-3.242c0-.202.126-.385.319-.453a3.45 3.45 0 0 1 3.372.578c.11.092.178.227.178.371v3.242a.48.48 0 0 1-.284.439 3.1 3.1 0 0 1-1.287.279zm-1.334-1.436a2.13 2.13 0 0 0 1.941.386v-2.669a2.5 2.5 0 0 0-1.026-.41 2.5 2.5 0 0 0-.91.03v2.663z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m36.208 43.677-7.707 4.47c-.516.294-.988.886-1.224 1.546l-5.039 13.584a2.6 2.6 0 0 0-.163.862v7.514c0 .439.144.747.41.896L4.222 62.005c-.26-.15-.41-.458-.41-.896v-7.514c0-.27.063-.564.164-.863L9.016 39.15c.236-.66.708-1.253 1.223-1.547l7.708-4.47 18.256 10.54z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.481 73.03a.5.5 0 0 1-.24-.062L3.983 62.424c-.42-.241-.65-.708-.65-1.315v-7.515c0-.313.067-.66.192-1.021l5.039-13.589c.27-.756.819-1.445 1.435-1.796l7.703-4.47a.48.48 0 0 1 .481 0l18.257 10.539a.483.483 0 0 1 0 .838l-7.708 4.47c-.419.241-.819.747-1.011 1.291l-5.039 13.589c-.086.25-.135.491-.135.693v7.515c0 .144.02.395.169.482a.487.487 0 0 1 .178.66.49.49 0 0 1-.419.24zm-4.533-39.34-7.466 4.33c-.42.242-.819.747-1.012 1.297L4.432 52.905c-.087.25-.135.492-.135.694v7.515c0 .115.014.395.168.481l17.13 9.89v-7.342c0-.318.067-.66.192-1.02l5.039-13.59c.27-.751.819-1.445 1.435-1.796l6.985-4.051L17.948 33.7z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m8.966 39.289-4.99 13.444c-.02.048-.025.096-.039.145l18.295 10.41v-.015l5.034-13.57L8.96 39.29z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.228 63.768a.46.46 0 0 1-.236-.063l-18.29-10.41a.48.48 0 0 1-.222-.563c.02-.077.03-.12.049-.163l4.99-13.45a.47.47 0 0 1 .29-.284.48.48 0 0 1 .404.034l18.304 10.414a.48.48 0 0 1 .212.588l-5.034 13.57a.49.49 0 0 1-.457.327zM4.521 52.655l17.457 9.933 4.696-12.669-17.456-9.932z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M6.612 58.059 3.813 56.42v2.731l2.8 1.638z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M6.614 61.273a.5.5 0 0 1-.241-.068l-2.799-1.637a.48.48 0 0 1-.24-.415v-2.731a.483.483 0 0 1 .722-.419l2.799 1.638c.149.086.24.245.24.414v2.731a.48.48 0 0 1-.24.42.5.5 0 0 1-.241.062zm-2.317-2.394 1.835 1.074v-1.614l-1.835-1.074z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M3.813 59.153v2.11a.89.89 0 0 0 .444.77l2.355 1.378v-2.625l-2.799-1.638z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M6.614 63.893a.5.5 0 0 1-.246-.067l-2.355-1.378a1.38 1.38 0 0 1-.68-1.185v-2.11a.483.483 0 0 1 .723-.419l2.799 1.638c.149.087.24.245.24.414v2.625a.48.48 0 0 1-.24.42.5.5 0 0 1-.241.062m-2.317-3.902v1.272c0 .145.077.28.202.356l1.628.954v-1.508l-1.835-1.074z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m22.04 66.967-2.793-1.633v2.731l2.793 1.633z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.042 70.18a.5.5 0 0 1-.241-.068l-2.799-1.637a.48.48 0 0 1-.24-.415v-2.73a.484.484 0 0 1 .722-.42l2.798 1.638c.15.087.241.245.241.414v2.731a.48.48 0 0 1-.24.42.5.5 0 0 1-.241.062zm-2.313-2.394 1.836 1.074v-1.614l-1.836-1.074z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.247 68.065v2.62l2.793 1.638v-2.625z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.042 72.804a.5.5 0 0 1-.241-.067l-2.799-1.638a.48.48 0 0 1-.24-.414v-2.62a.483.483 0 0 1 .722-.42l2.798 1.638c.15.087.241.246.241.414v2.626a.48.48 0 0 1-.24.419.5.5 0 0 1-.241.062m-2.313-2.394 1.836 1.074v-1.507l-1.836-1.075z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.21 59.616v-15.94l-7.707 4.47c-.516.294-.988.887-1.224 1.547L22.24 63.276a2.6 2.6 0 0 0-.163.863v7.514c0 .438.144.747.41.896.023.014.047.024.071.039.256.11.578.072.92-.126l6.759-3.877c.49-1.922 1.845-3.892 3.439-4.808.862-.496 1.657-.607 2.278-.37h.01c.342.202.621.419.828.62a1.6 1.6 0 0 1 .285.521v.01l.029.086 26.936-15.462c.487-1.932 1.845-3.907 3.444-4.822.862-.496 1.657-.607 2.279-.37h.01c.341.202.62.418.828.62.125.145.217.328.284.52v.01a.6.6 0 0 1 .034.097l2.418-1.387c.77-.444 1.402-1.532 1.402-2.419v-3.93L36.215 59.625z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.86 73.126c-.173 0-.342-.033-.496-.1-.048-.02-.087-.044-.125-.063-.42-.241-.65-.709-.65-1.315v-7.515c0-.313.067-.66.192-1.021l5.039-13.589c.27-.751.819-1.445 1.435-1.797l7.702-4.47a.484.484 0 0 1 .723.42V58.78l37.804-21.71a.483.483 0 0 1 .723.419v3.931c0 1.06-.723 2.307-1.643 2.832l-2.419 1.388a.482.482 0 0 1-.689-.25c0-.006-.019-.054-.019-.059-.004-.014-.01-.038-.019-.057a1.1 1.1 0 0 0-.198-.367 4 4 0 0 0-.655-.486c-.496-.183-1.156-.063-1.854.342-1.455.833-2.746 2.65-3.218 4.523a.5.5 0 0 1-.226.299L37.33 65.043a.47.47 0 0 1-.4.034.48.48 0 0 1-.289-.284c0-.005-.019-.053-.019-.058l-.014-.058a1.2 1.2 0 0 0-.193-.361 4 4 0 0 0-.655-.486c-.496-.183-1.156-.063-1.855.341-1.445.83-2.74 2.64-3.213 4.51a.5.5 0 0 1-.226.298l-6.758 3.877c-.284.17-.573.251-.853.251zM35.726 44.51l-6.98 4.05c-.419.242-.819.747-1.011 1.292l-5.039 13.588c-.086.25-.135.492-.135.694v7.514c0 .145.024.395.169.482.14.063.313.024.506-.087l6.59-3.78c.573-2.034 2.008-3.99 3.612-4.904.959-.554 1.874-.699 2.65-.42q.066.017.125.053c.366.217.684.458.92.694q.114.13.197.275l26.296-15.092c.573-2.038 2.009-3.998 3.618-4.923.958-.554 1.873-.698 2.649-.419q.066.016.125.053c.366.222.684.458.92.694.077.091.145.183.203.284l1.95-1.123c.617-.356 1.157-1.29 1.157-1.999v-3.097l-37.804 21.71a.483.483 0 0 1-.722-.42v-15.1z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m34.237 47.544-5.01 2.885-3.049 9.249 8.059-4.639z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M26.18 60.155a.5.5 0 0 1-.304-.106.485.485 0 0 1-.154-.525l3.05-9.249a.5.5 0 0 1 .216-.265l5.015-2.88a.484.484 0 0 1 .723.42v7.494a.48.48 0 0 1-.242.42l-8.063 4.633a.5.5 0 0 1-.241.063zm3.449-9.403-2.597 7.876 6.73-3.868v-6.383z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M24.44 63.141a.483.483 0 0 1-.482-.481c0-.891.087-1.007.858-1.787.477-.477.525-.92.54-1.084.023-.241.14-.4.332-.468a.482.482 0 0 1 .621.574 2.72 2.72 0 0 1-.814 1.657q-.578.583-.578 1.108a.483.483 0 0 1-.482.481z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M28.27 61.238a2.6 2.6 0 0 1-1.434.212 2.63 2.63 0 0 1-1.465-.713v-3.242c.255-.091.79-.246 1.465-.145a3 3 0 0 1 1.435.646z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.187 61.955q-.203 0-.42-.029a3.16 3.16 0 0 1-1.733-.842.48.48 0 0 1-.15-.347v-3.242c0-.202.125-.385.318-.453a3.45 3.45 0 0 1 3.372.578c.11.092.173.227.173.371v3.242c0 .188-.11.361-.279.438-.299.135-.742.28-1.286.28zm-1.34-1.435a2.13 2.13 0 0 0 1.942.385v-2.668a2.47 2.47 0 0 0-1.937-.38v2.663z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <clipPath id="a">
        <path
          d="M3.334 6.667h72.043v66.46H3.334z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
      </clipPath>
    </g>
  </InceptIcon>
);

export const IconAssetTruck = memo(IconAssetTruckComponent);
